/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Faq_Q7Inputs */

const en_minifier_faq_q7 = /** @type {(inputs: Minifier_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does minifying lose precision on large numbers?`)
};

const ko_minifier_faq_q7 = /** @type {(inputs: Minifier_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`압축이 큰 숫자의 정밀도를 잃게 하나요?`)
};

const ja_minifier_faq_q7 = /** @type {(inputs: Minifier_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮は大きな数値の精度を失わせますか`)
};

/**
* | output |
* | --- |
* | "Does minifying lose precision on large numbers?" |
*
* @param {Minifier_Faq_Q7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_faq_q7 = /** @type {((inputs?: Minifier_Faq_Q7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Faq_Q7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_faq_q7(inputs)
	if (locale === "ko") return ko_minifier_faq_q7(inputs)
	return ja_minifier_faq_q7(inputs)
});